import api from './api';

export async function fetchActionHistory(params = {}) {
  const { data } = await api.get('/api/action-history', { params });
  return data;
}

export async function undoAction(id, userName) {
  const { data } = await api.post(`/api/action-history/${encodeURIComponent(id)}/undo`, {
    user_name: userName || 'System',
  });
  return data;
}
